import { PSection, PBox, PText, PH1, PImg } from "../theme/BaseTheme";

const UseCases = ({ data = [], title = "" }) => {
    return (
        <PSection css={styles}>
            <PBox className="use-cases">
                <PBox className="use-cases-container">
                    <PText className="use-cases-subtitle">
                        Discover the Possibilities
                    </PText>
                    <PH1 className="use-cases-title">{title}</PH1>

                    <PBox className="use-cases-wrapper">
                        {data.map((useCase, idx) => (
                            <PBox key={idx} className="use-cases-item">
                                <PBox className="use-cases-item-image">
                                    <PImg
                                        src={useCase.image}
                                        alt={useCase.title}
                                    />
                                </PBox>
                                <PBox className="use-cases-item-content">
                                    <PText className="use-cases-item-title">
                                        {useCase.title}
                                    </PText>
                                    <PText className="use-cases-item-description">
                                        {useCase.description}
                                    </PText>
                                </PBox>
                            </PBox>
                        ))}
                    </PBox>
                </PBox>
            </PBox>
        </PSection>
    );
};

const styles = {
    fontFamily:
        "Inter var, ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    "& .use-cases": {
        padding: "0 1.5rem 0.5rem 1.5rem",
        maxWidth: "80rem",
        margin: "2rem auto",
        "@bp2": { marginTop: "2rem" },
        "@bp4": { paddingLeft: "4rem", paddingRight: "4rem" },
    },
    "& .use-cases-container": {
        position: "relative",
        marginLeft: "auto",
        marginRight: "auto",
    },
    "& .use-cases-subtitle": {
        color: "$colors$primary",
        lineHeight: "1.75rem",
        fontWeight: "600",
        fontSize: "1rem",
        textAlign: "center",
    },
    "& .use-cases-title": {
        color: "rgb(17 24 39)",
        fontWeight: "700",
        fontSize: "1.875rem",
        lineHeight: "2.5rem",
        marginTop: "0.5rem",
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        "@bp2": { fontSize: "2.25rem", lineHeight: "3rem" },
    },
    "& .use-cases-wrapper": {
        position: "relative",
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        paddingBottom: "0.5rem",
        maxWidth: "80rem",
        marginTop: "4rem",
        marginBottom: "4rem",
        marginLeft: "auto",
        marginRight: "auto",
        display: "grid",
        maxWidth: "42rem",
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        gap: "2rem",
        "@bp2": {
            maxWidth: "none",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop: "4rem",
            marginBottom: "4rem",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        },
        "@bp3": {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        },
    },
    "& .use-cases-item": {
        position: "relative",
        borderRadius: "0.75rem",
        overflow: "hidden",
        backgroundColor: "white",
        boxShadow:
            "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        transition: "all .3s ease-in-out",
        "-moz-transition": "all .3s ease-in-out",
        "-webkit-transition": "all .3s ease-in-out",
        "&:hover": {
            transform: "translateY(-6px)",
            boxShadow:
                "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            "& img": {
                transform: "scale(1.1)",
                "-moz-transform": "scale(1.1)",
                "-webkit-transform": "scale(1.1)",
            },
        },
    },
    "& .use-cases-item-image": {
        overflow: "hidden",
        height: "320px",
        "& img": {
            width: "100%",
            height: "100%",
            objectPosition: "center",
            objectFit: "cover",
            transition: "all .3s ease-in-out",
            "-moz-transition": "all .3s ease-in-out",
            "-webkit-transition": "all .3s ease-in-out",
        },
    },
    "& .use-cases-item-content": {
        padding: "1.5rem",
        textAlign: "left",
    },
    "& .use-cases-item-title": {
        color: "rgb(17 24 39)",
        fontWeight: "700",
        fontSize: "1.25rem",
        marginBottom: "0.75rem",
    },
    "& .use-cases-item-description": {
        color: "rgb(75 85 99)",
        fontSize: "0.875rem",
        lineHeight: "1.25rem",
    },
};

export default UseCases;
